import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./pages/Navbar";
import Login from "./pages/Login";
import AuthService from "./services/AuthService";
import PrivateRoute from "./components/PrivateRoute";
import { protectedRoutes } from "./routes";

export default function App() {
  const [currentUser, setCurrentUser] = useState(null);

  // Brišemo token pri startu
  useEffect(() => {
    AuthService.logout();
    setCurrentUser(null);
  }, []);

  return (
    <Router>
      {/* Navbar samo ako je korisnik ulogovan */}
      {currentUser && <Navbar setCurrentUser={setCurrentUser} />}

      <Routes>
        {/* Login ruta */}
        <Route path="/" element={<Login setCurrentUser={setCurrentUser} />} />

        {/* Zaštićene rute */}
        {protectedRoutes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={<PrivateRoute>{element}</PrivateRoute>}
          />
        ))}

        {/* Svi ostali URL-ovi -> preusmeravanje na login */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}
